import React from "react";
import { withTheme } from "styled-components";
import { useSiteConfig } from "components/Site/Contexts/SiteConfig";
import OutsideClickHandler from "react-outside-click-handler";

import { DropdownTrigger, DropdownContent } from "../../../AppBar/Dropdown";
import { BibleList } from "./BibleList/BibleList";
import { AllBiblesList } from "./AllBiblesList";
import { StateBible, useBible } from "../../../Bible/BibleContainer";
import BookLibraryIcon from "../../../../icons/BookLibraryIcon";
import { getMaxMenuHeight } from "../utils";
import { Theme } from "typedefs-ui/Theme";
import { useScriptureRouting } from "components/Bible/useScriptureRouting";
import { Bible } from "api/typedefs/Bible";

interface BibleDropdownProps {
  parallelIndex?: number;
  isOpen: boolean;
  toggle: (reset?: boolean) => void;
  theme: Theme;
}

const BibleDropdown = ({
  parallelIndex,
  isOpen,
  toggle,
  theme
}: BibleDropdownProps) => {
  const { biblesById } = useBible();
  const site = useSiteConfig();
  const {
    setBible,
    bibleId: routeBibleId,
    parallelBibleIds
  } = useScriptureRouting();

  // TODO: consolidate this and ChapterBar.tsx
  const bibles = Object.keys(biblesById)
    .map(id => biblesById[id] as StateBible)
    .filter(bible => bible);
  const bibleId = parallelIndex
    ? parallelBibleIds[parallelIndex]
    : routeBibleId;
  const currentBible = biblesById[bibleId];

  const siteBibleIds =
    site && site.bibles ? site.bibles.map((bible: Bible) => bible.id) : [];

  const handleBibleClick = (bibleId: string) => {
    toggle(true);
    setBible({ bibleId, parallelIndex });
  };

  return (
    <div>
      <OutsideClickHandler onOutsideClick={() => isOpen && toggle()}>
        <DropdownTrigger arrow toggle={() => toggle()} isOpen={isOpen}>
          <BookLibraryIcon fill={theme.appBarText} size={24} />
        </DropdownTrigger>
        {site.includeAllBibles ? (
          isOpen && (
            <AllBiblesList
              bibles={bibles}
              siteBibleIds={siteBibleIds}
              currentBibleId={currentBible?.id || ""}
              onBibleClick={handleBibleClick}
            />
          )
        ) : (
          <DropdownContent
            isOpen={isOpen}
            style={{ height: getMaxMenuHeight() }}
          >
            <BibleList
              bibles={bibles}
              siteBibleIds={siteBibleIds}
              currentBibleId={currentBible?.id || ""}
              onBibleClick={handleBibleClick}
            />
          </DropdownContent>
        )}
      </OutsideClickHandler>
    </div>
  );
};

export default withTheme(BibleDropdown);
